// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"238":"83669268","239":"c79a298f"}[chunkId] + ".chunk.js");